import React, { useEffect, useState, useRef  } from "react";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import axios from "axios";

import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Section from "react-bootstrap/Container";
import Slider from "react-slick";
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';

import icoInvestigacion from '../Portafolio/src/imgs/slider/investigacion.svg';
import icoDiplomados from '../Portafolio/src/imgs/slider/diplomados.svg';
import icoCertificaciones from '../Portafolio/src/imgs/slider/certificaciones.svg';
import icoPosgrados from '../Portafolio/src/imgs/slider/posgrados.svg';
import moodleban from '../../images/user-landing/moodle-banner.png';
import moodlelog from '../../images/user-landing/moodle-logo.png';
import questiban from '../../images/user-landing/preguntas-banner.png';
import questilog from '../../images/user-landing/preguntas-logo.png';
import contacban from '../../images/user-landing/contacto-banner.png';

import LoadingComponent from "../../app/layout/LoadingComponent";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import ContactModalForm from "../Modals/ContactModalForm";


export default observer (function HomeProfile() {

    const [curso, setCursos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [usrtelefon, setUsrtelefon] = useState("");
  const { CATCursosStore, userStore: { user, logout } } = useStore();
  const { loadCATCursos, getCATCursosRegistryAll } = CATCursosStore;
  const AutoPlaySwipeableViews: any = autoPlay(SwipeableViews);
  const perfilAPI = process.env.REACT_APP_API_URL + `/Courses/MyCourses?Student=${user?.id}`;
  const data_cursos = CATCursosStore.getCATCursosByCodigoAll;

  const usrnombre: string | undefined = user?.displayName;
  const usrucorreo: string | undefined = user?.email;

  
  const settings = {
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    swipe: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1104, // Cuando la pantalla es menor a 1024px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 480, // Cuando la pantalla es menor a 600px (típicamente tablets y algunos móviles)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 480, // Cuando la pantalla es menor a 480px (típicamente móviles)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };

  

  const openModal = () => {
    setModalShow(true);
     };
  
  type EditionsType = {
    id: number;
    // ... y otros campos que quieras agregar si es necesario
  }
  
  type CursosItemProps = {
    key: number;
    id: number;
    codigoCurso: string;
    contacto: string;
    delegacion: number;
    imageUrl: string;
    modalidad: string;
    nivel: number;
    nombre: string;
    editions: EditionsType;  // <-- Cambio aquí, de 'Editions: number' a 'editions: EditionsType'
}

  const [offset, setOffset] = useState(0);
  const slideWidth = 348;  // Ancho de cada slide
  
  const getVisibleSlides = () => {
    if (window.innerWidth >= 1450) {
        return 3;
    } else if (window.innerWidth >= 769) {
        return 2;
    } else {
        return 1;
    }
}



const [windowWidth, setWindowWidth] = useState(window.innerWidth);

useEffect(() => {

  
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);

  const getCourses = async () => {
    

    const responseConvenio = await axios(perfilAPI);
    const { data } = responseConvenio;

    const cursos = data.map(
      (dataR: {
        key: number;
        id: number;
        codigoCurso: string;
        contacto: string;
        delegacion: number;
        imageUrl: any;
        modalidad: string;
        nivel: number;
        nombre: string;
        editions: EditionsType;

      }) => {

        return {
          key: dataR.id,
          id: dataR.id,
          imageUrl: dataR.imageUrl,
          nombre: dataR.nombre,
          modalidad: dataR.modalidad,
          nivel: dataR.nivel,
          delegacion: dataR.delegacion,
          editions: dataR.editions

        };
      }
    );
    
    return cursos;
  }; 
  
  useEffect(() => { 
    let isMounted = true;
    if(isMounted){  //comprobando que el componente esta montado antes de cambiar estados
      setLoading(true);
    }
    getCourses().then((cursos) => {
      if(isMounted){
        setCursos(cursos)
        setLoading(false);
      }
    })
    return () => {
        isMounted = false;
    };
  }, []);

  const CursosItems = (item: CursosItemProps) => {
    return (
      <a className={"col-md-4 col-sm-12"} href={`https://aulavirtual.inap.gob.gt/course/view.php?id=${item.editions?.id}`} target="_blank">  
  
        <div className="profile-card" style={{ backgroundImage: `url(${item.imageUrl})` }}>
          <h3>{item.nombre}</h3>
          {/* <ProgressBar className="pro-indic" now={75} />
          <p>{25}%</p> */}
          <div className="image-filter"></div>
        </div>
      </a>


        // <div className="profile-card col-md-4 col-sm-12" style={{ backgroundImage: `url(${item.imageUrl})` }}>
        //   <h3>{item.nombre}</h3>
        //   {/* <ProgressBar className="pro-indic" now={75} />
        //   <p>{25}%</p> */}
        //   <div className="image-filter"></div>
        // </div>
      


    );
  };

  useEffect(() => {
    if (getCATCursosRegistryAll.size <= 1) {
      loadCATCursos();
    }
  }, [getCATCursosRegistryAll.size, loadCATCursos]);

    return(
        <>
            <Col md={16}>

                <Section className="search-section">
                <h2>Buscar curso</h2>

                <Row className="search-area">
                    <div className="buscador-row">
                        <BuscadorComponent />
                    </div>
                </Row>
                
                </Section>


                <Section className="otros-section">
                    <h2>Buscar por Categorías</h2>

                    <Row className="category-area">

                    <Link to='/asesorias' >
                        <Col className="category cat-1"> <img src={icoInvestigacion} alt="Investigación, asesoría, y asistencia técnica" /> <p>Investigación, asesoría, y asistencia técnica</p></Col>
                    </Link>

                    <Link to='/certificaciones' >
                        <Col className="category cat-2"> <img src={icoCertificaciones} alt="Certificaciones" /> <p>Certificaciones</p></Col>
                    </Link>

                    <Link to='/cursos' >
                        <Col className="category cat-3"> <img src={icoDiplomados} alt="Cursos y Diplomados" /> <p>Cursos y Diplomados</p></Col>
                    </Link>

                    <Link to='/posgrados' >
                        <Col className="category cat-4"> <img src={icoPosgrados} alt="Estudios de Postgrados" /> <p>Estudios de Postgrados</p></Col>
                    </Link>

                    </Row>

                </Section>



                <Section className="cursos-cards-area">
                    <h2>Mis cursos en progreso</h2>

                    <Section className="cards-row">
                    
                    <Slider key={windowWidth} {...settings}>
                    {curso.length 
                        ? loading 
                        ? <LoadingComponent content="Cargando perfil..." key={Math.random()} />
                        : curso.map((CU: CursosItemProps) => <CursosItems {...CU} />)
                        : <div className="alert-no-content"><p>Aún no tienes cursos asignados</p></div>
                    }
                    </Slider>

                </Section>

                </Section>

                <Section className="help-section">
                <Row className="profile-grid-area">
                    <Col className="profile-section">
                    <h2>Enlaces de interés</h2>
                    <Row className="moodle">
                    <a href={'https://aulavirtual.inap.gob.gt/ingresar'} target="_blank" className="long-section">
                        <Row className="moodle-area" style={{ backgroundImage: `url(${moodleban})` }}>
                        <h3>Ingresa al aula virtual - INAP</h3>
                        <img src={moodlelog} alt="Ingresa a nuestra aula virtual" />
                        <div className="image-filter"></div>
                        </Row>
                    </a>
                    </Row>
                    

                    <Row className="interes-area">

                        <Link to={'/preguntas_frecuentes'}>
                        <Col className="inte preguntas-area" style={{ backgroundImage: `url(${questiban})` }}>
                            <h3>Preguntas Frecuentes</h3>
                            <img src={questilog} alt="Preguntas Frecuentes" />
                        </Col>
                        </Link>

                        <a onClick={openModal} >
                        <Col className="inte contacto-area" style={{ backgroundImage: `url(${contacban})` }}>
                            <h3>Contácto y Soporte</h3>
                        </Col>
                        </a>

                    </Row>

                    </Col>
                    </Row>
                </Section>


            </Col>

                <ContactModalForm
            onHide={() => { setModalShow(false) }}
            show={modalShow}
            cnombre={usrnombre}
            ccorreo={usrucorreo}
            />
        </>
    )
});